module.exports = __webpack_public_path__ + "static/media/class_small_warrior.8656e5cc.png";